export default {
  labels: {
    signed_by: 'Signé par {{name}} le {{date}}',
    signed_by_no_date: 'Signé par {{name}}',
  },
  buttons: {
    retry: 'Réessayer',
  },
  errors: {
    load_failed: 'Le contrat n’a pas pu être chargé. Vérifiez votre connexion et réessayez.',
  },
};
